var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-widget-wrapper",class:("d-flex justify-content-" + (_vm.content.style.horizontal))},[_c('b-img',{style:(_vm.getStyle),attrs:{"src":_vm.content.src,"fluid":"","alt":"Responsive image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }